import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {BootstrapLicenseDataService} from '@core/services';
import {ERROR_PAGES_404_ROUTE} from '@core/constants/navigation';

@Injectable({
  providedIn: 'root'
})
export class RiskRatingModuleGuard  {
  constructor(
    private router: Router,
    private bootstrapLicenseData: BootstrapLicenseDataService,
  ) { }

  canActivate(): boolean {
    if (this.bootstrapLicenseData.getBootstrapData().modules.evaluation) {
      return true;
    }

    this.router.navigateByUrl(ERROR_PAGES_404_ROUTE);
    return false;
  }
}
